import { EMBEDDED_DELETE_ACCOUNT_CHANNEL, EMBEDDED_LOGOUT_CHANNEL, EMBEDDED_UA_MARKER } from "global/constants";

/* eslint-disable @typescript-eslint/no-explicit-any */
type NativeBridgeWindow = Window & {
  webkit?: { messageHandlers?: Record<string, { postMessage?: (message: any) => void } | undefined> };
  [EMBEDDED_LOGOUT_CHANNEL]?: { postMessage?: (message: any) => void };
  [EMBEDDED_DELETE_ACCOUNT_CHANNEL]?: { postMessage?: (message: any) => void };
};
/* eslint-enable @typescript-eslint/no-explicit-any */

export const isEmbeddedApp = (): boolean => navigator.userAgent.includes(EMBEDDED_UA_MARKER);

type NativeChannel = typeof EMBEDDED_LOGOUT_CHANNEL | typeof EMBEDDED_DELETE_ACCOUNT_CHANNEL;
export const notifyNativeLogout = (): void => postToNativeChannel(EMBEDDED_LOGOUT_CHANNEL, "logout");
export const notifyNativeDeleteAccount = (): void => postToNativeChannel(EMBEDDED_DELETE_ACCOUNT_CHANNEL, "");

const postToNativeChannel = (channel: NativeChannel, message: string): void => {
  if (!isEmbeddedApp()) {
    return;
  }

  try {
    const nativeWindow = window as NativeBridgeWindow;

    const iosHandler = nativeWindow.webkit?.messageHandlers?.[channel];
    if (iosHandler?.postMessage) {
      iosHandler.postMessage(message);
      return;
    }

    const androidHandler = nativeWindow[channel];
    if (androidHandler?.postMessage) {
      androidHandler.postMessage(message);
    }
  } catch {
    // No native bridge (e.g. plain browser, not the app) - ignore.
  }
};
